export const DEFAULT_AVATAR_ID = 'avatar';
export const DEFAULT_WORKSPACE_ID = '';
